import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import './CommonPopup.css';
import EnquiryForm from './EnquiryForm';
import enquirybanner from '../assets/images/uniworld-new-5.jpg';
import Footer from "./Footer";
import Navbar from './Navbar';
import SocialLinks from "./SocialLinks";
import axiosInstance from '../axiosInstance';
import { ModalContext } from '../context/ModalContext';
import { getFullImageUrl } from '../utils/apiBase';


const Layout = ({ children }) => {

  const [popupData, setPopupData] = useState([]);
  const [showEnquiryPopup, setShowEnquiryPopup] = useState(false);
  const [showOtherPopup, setShowOtherPopup] = useState(false);
  
  useEffect(() => {
      const fetchData = async () => {
          try {
              const res = await axiosInstance.get("/api/openpopup"); // Adjust port if needed
              const fetchedData = Array.isArray(res.data) ? res.data : []; // Assuming data is an array
              setPopupData(fetchedData);
          } catch (err) {
              console.error("Error fetching data:", err);
              setPopupData([]); // fallback
          }
      };
      fetchData();
  }, []);

  // First-time logic
  // useEffect(() => {
  //   const enquiryDone = localStorage.getItem("enquiryDone");
  //   if (!enquiryDone) {
  //     if (popupData.length > 0) {
  //     // If popup available in date → show that first
  //     setShowOtherPopup(true);
  //     } else {
  //       // If no popup → show enquiry directly
  //       setShowEnquiryPopup(true);
  //     }
  //   } else {
  //     // If enquiry already done → only show popup if available
  //     if (popupData.length > 0) {
  //       setShowOtherPopup(true);
  //     }
  //   }
  // }, [popupData]);

  // // Prevent scrolling when popup is open
  // useEffect(() => {
  //   if (showEnquiryPopup || showOtherPopup) {
  //     document.body.style.overflow = 'hidden';
  //   } else {
  //     document.body.style.overflow = 'unset';
  //   }
  // }, [showEnquiryPopup, showOtherPopup]);

  // Handle enquiry success
  const handleEnquirySuccess = () => {
    localStorage.setItem("enquiryDone", true);
    setShowEnquiryPopup(false);
  };

  // Close other popup → then immediately show enquiry (if not done)
  const closeOtherPopup = () => {
    setShowOtherPopup(false);
    const enquiryDone = localStorage.getItem("enquiryDone");
    if (!enquiryDone) {
      setShowEnquiryPopup(true);
    }
  };  
    
  // Close enquiry popup
  const closePopUp = () => {
    localStorage.setItem("enquiryDone", true);
    setShowEnquiryPopup(false);
  };

  //localStorage.setItem("enquiryDone", true);

  return (
    <>    
      <ModalContext.Provider value={{setShowEnquiryPopup}}>
      <Navbar />
      <SocialLinks />
      <div>{children}</div>
      <Footer />
      {showEnquiryPopup && !localStorage.getItem("enquiryDone") && (
        <Popup open={true} onClose={closePopUp} closeOnDocumentClick={false} closeOnEscape={false} modal>
          <div className="modal">
            {localStorage.getItem("enquiryDone") && (
              <Link className="close" onClick={() => setShowEnquiryPopup(false)}>
                &times;
              </Link>
            )}
            <div className='flex flex-row content overflow-hidden'>
              <div className='grid grid-cols-1 md:grid-cols-2 grow gap-0'>
                <div className='hidden md:flex relative'>
                  <div className='absolute w-full h-full bg-no-repeat bg-cover bg-center z-0 top-0 left-0' style={{backgroundImage:`url(${enquirybanner})`}}></div>
                </div>
                <div className='flex'>
                  <EnquiryForm title={'Express Your Interest'} />
                </div>
              </div>
            </div>
          </div>
        </Popup>
      )}
      {showOtherPopup && (
      <Popup open={true} onClose={closeOtherPopup} className={'home-popup'} modal>
        <div className="modal">
          <Link className="close" onClick={closeOtherPopup}>&times;</Link>
          <div className='flex flex-row content overflow-hidden'>
              {popupData.map((popup, index) => (
                <img key={index} src={getFullImageUrl(popup.webppath)} alt={popup.alttext || "Popup"} className='w-full' />
              ))}
          </div>
        </div>
      </Popup>
      )}
      </ModalContext.Provider>
      
    </>
  );
};

export default Layout;